export const FONT_SIZE = {
  PX_12: '12px',
  PX_13: '13px',
  PX_14: '14px',
  PX_15: '15px',
  PX_16: '16px',
  PX_18: '18px',
  PX_20: '20px',
  PX_22: '22px',
  PX_23: '23px',
  PX_24: '24px',
  PX_28: '28px',
  PX_30: '30px',
  PX_32: '32px'
};

export const SPECIAL_CHARACTER_VALIDATION = {
  FOR_NAMES: /[%<>\\$#!@%^&*()?+'"]/,
  FOR_SPACE: /\s/g,
  FOR_NBSP: /(&nbsp;)*/g,
  FOR_COMMA: /[,.]/g
};

export const INDUSTRIES_OPTION = [
  { value: '', name: '—Please choose an option—' },
  { value: 'Art and Antiquities', name: 'Art and Antiquities' },
  { value: 'Banking and Financial services', name: 'Banking and Financial services' },
  { value: 'Construction', name: 'Construction' },
  { value: 'Consulting', name: 'Consulting' },
  { value: 'Digital Marketing', name: 'Digital Marketing' },
  { value: 'Education', name: 'Education' },
  { value: 'Energy', name: 'Energy' },
  { value: 'Engineering', name: 'Engineering' },
  { value: 'Entertainment', name: 'Entertainment' },
  { value: 'Healthcare', name: 'Healthcare' },
  { value: 'Hospitality / Tourism', name: 'Hospitality / Tourism' },
  { value: 'Insurance', name: 'Insurance' },
  { value: 'Investment', name: 'Investment' },
  { value: 'Manufacturing', name: 'Manufacturing' },
  { value: 'Media & Communication', name: 'Media & Communication' },
  { value: 'Mining', name: 'Mining' },
  { value: 'Online Business', name: 'Online Business' },
  { value: 'Real Estate', name: 'Real Estate' },
  { value: 'Services', name: 'Services' },
  { value: 'Technology', name: 'Technology' },
  { value: 'Telecommunications', name: 'Telecommunications' },
  { value: 'Trading of goods', name: 'Trading of goods' }
];

export const COLORS = {
  RED: '#FF0000',
  BLUE: '#0096FF',
  BLUE500: '#06f',
  Blue600: '#027bff',
  WHITE: '#FFFFFF'
};

export const LINKS = {
  whatsapp: 'https://wa.me/+85298138802',
  whatsapp_subscribe: 'https://api.whatsapp.com/send/?phone=%2B85298138802&text&type=phone_number&app_absent=0',
  youtube_subscribe: 'https://www.youtube.com/channel/UC5kOyyX_q6roLcQAE_CLkkw',
  linkedin: 'https://www.linkedin.com/in/vivian-au-air-corporate-b9419a20a/',
  companies_registry: 'https://www.tcsp.cr.gov.hk/tcspls/search/public-search?k=TC008778',
  login: 'https://rcx-cloudtechnologies.com/login'
};

export const PACKAGE_PRICE = {
  BASIC: 90,
  EXPERT: 1405,
  ALL_INCLUSIVE: 1070
};
export const PACKAGE_PRICE_FOR_RENDER = {
  BASIC: '90',
  EXPERT: '1,405',
  ALL_INCLUSIVE: '1,070'
};

export const ACCOUNTING_PRICE = {
  LIGHT: 95,
  SMALL_BUSINESS: 150,
  GROWTH: 215
};

export const HUBSPOT_INTEGRATION = {
  SIGN_UP: 'https://api.hsforms.com/submissions/v3/integration/submit/9365432/e7c62328-8280-44c2-88cf-e5070069f277',
  CONTACT_US: 'https://api.hsforms.com/submissions/v3/integration/submit/9365432/fa17bfc7-3f41-4a76-924a-b4c7e5dbc773',
  ACCOUNTING: 'https://api.hsforms.com/submissions/v3/integration/submit/9365432/85862214-faec-4d2f-af2a-797e5db58b75'
};
export const EMAIL_JS = {
  PUBLIC_KEY: '6yRKYT1zDWtRYk1X-',
  EMAIL_JS_SERVICE_ID: 'ac_emails',
  GET_STARTED_TEMPLATE_ID: 'getstarted',
  CONTACT_TEMPLATE_ID: 'contactus'
};
export const URLS = {
  SITE_URL: 'https://air-corporate.com'
};
export const API_CODE = {
  STATUS_200: 200,
  STATUS_201: 201,
  STATUS_204: 204
};
export const API_ERROR_CODES = {
  STATUS_400: 400,
  STATUS_401: 401,
  STATUS_402: 402,
  STATUS_403: 403,
  STATUS_404: 404,
  STATUS_412: 412,
  STATUS_422: 422,
  STATUS_500: 500
};

export const REGEX = {
  UPPER_CASE_REGEX: /(?=.*[A-Z])/,
  LOWER_CASE_REGEX: /(?=.*[a-z])/,
  DIGIT_CASE_REGEX: /(?=.*\d)/,
  SPECIAL_CASE_REGEX: /(?=.*[-+_!@#$%^&*.,?])/,
  SPACE_REGEX: /(?=.*\s)/,
  EMAIL_REGEX: /^(?=[\w\s-+.])\s*[-+.'\w]+@[-.\w]+\.[-.\w]+\s*$/,
  HUBSPOT_COOKIE_REGEX: '(^|;)\\s*hubspotutk\\s*=\\s*([^;]+)',
  ONLY_STRING_REGEX: /([A-Za-z])$/,
  REPLACE_STRING_REGEX: /[^\d.-]/g,
  REPLACE_SLASH: /\//g,
  EXCEPT_SLASH_AND_QUOTES_REGEX: /^[^/\\'"]+$/,
  FIND_ALL_WHITESPACE: /\s/g,
  CARD_NUMBER_SPACE_REGEX: /\d{4}(?=.)/g,
  WATCH: /watch\?v=/,
  ONLY_ALPHABETS_AND_SPACE_ALLOWED: /^[A-Za-z\s]*$/
};
